// A label the platform proposes for the device: system and browser, editable
// by the operator.
//
// INC-06b-2b (D-179, criterion 65): the words are the catalog's, like every
// other string a person reads. What this module decides is which system and
// which browser it is; what those are called is not its business.
//
// INC-15b-2 (M, D-409): "[navegador] en [sistema]" -- "Chrome en Android",
// "Safari en iPad" --, and "Dispositivo sin nombre" when either cannot be told;
// an iPad and an iPhone are named apart.
export type DeviceSystem =
  'android' | 'ipad' | 'iphone' | 'ios' | 'windows' | 'macos' | 'linux' | 'unknown';
export type DeviceBrowser = 'edge' | 'chrome' | 'firefox' | 'safari' | 'unknown';

export function detectSystem(userAgent: string): DeviceSystem {
  if (/Android/i.test(userAgent)) return 'android';
  if (/iPad/i.test(userAgent)) return 'ipad';
  if (/iPhone/i.test(userAgent)) return 'iphone';
  if (/iPod/i.test(userAgent)) return 'ios';
  if (/Windows/i.test(userAgent)) return 'windows';
  if (/Mac OS/i.test(userAgent)) return 'macos';
  if (/Linux/i.test(userAgent)) return 'linux';
  return 'unknown';
}

export function detectBrowser(userAgent: string): DeviceBrowser {
  // INC-15b-2 (M): the browsers of an iPad or an iPhone say who they are with
  // names of their own (EdgiOS, CriOS, FxiOS) before the Safari they run on.
  if (/Edg(iOS|A)?\//i.test(userAgent)) return 'edge';
  if (/(Chrome|CriOS)\//i.test(userAgent)) return 'chrome';
  if (/(Firefox|FxiOS)\//i.test(userAgent)) return 'firefox';
  if (/Safari\//i.test(userAgent)) return 'safari';
  return 'unknown';
}

/** The proposed label, built from the catalog. `t` is the caller's, so this
 *  module holds no visible text of its own. */
export function proposeDeviceLabel(
  userAgent: string,
  t: (key: string, values?: Record<string, string>) => string,
): string {
  const system = detectSystem(userAgent);
  const browser = detectBrowser(userAgent);
  if (system === 'unknown' || browser === 'unknown') return t('device.unnamed');
  return t('device.label', {
    system: t(`device.systems.${system}`),
    browser: t(`device.browsers.${browser}`),
  });
}
